import { Command } from 'pos/common';
import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Permission, InvoiceDTO } from 'core/api';
import * as InvoiceStore from './InvoiceStore';

declare global {
	interface CommandType {
		printInvoiceCoupons: (invoice: InvoiceDTO) => Promise<Result>
	}
}

Command.register('printInvoiceCoupons', Preconditions.and(Preconditions.ensure(Permission.Coupon_Print), Preconditions.ensureIsNotLite), async (invoice: InvoiceDTO): Promise<Result> => {
	await InvoiceStore.printCoupons(invoice.Id);
	return Result.ok();
});
